import { defineMessages } from 'react-intl-next';

export const messages = defineMessages({
	actionChatToAgent: {
		id: 'ptc-directory.agent-profile.action.dropdown.chat-to-agent.nonfinal',
		defaultMessage: 'Chat to Agent',
		description: 'Text for the "chat to agent" action to chat to the agent',
	},
	actionDelete: {
		id: 'ptc-directory.agent-profile.action.dropdown.delete.nonfinal',
		defaultMessage: 'Delete Agent',
		description: 'Text for the "Delete" action to delete an agent',
	},
	actionEdit: {
		id: 'ptc-directory.agent-profile.action.dropdown.edit.nonfinal',
		defaultMessage: 'Edit Agent',
		description: 'Text for the "Edit" action to edit an agent',
	},
	actionCopyLink: {
		id: 'ptc-directory.agent-profile.action.dropdown.copy-link.nonfinal',
		defaultMessage: 'Copy link',
		description: 'Text for the Copy link of an agent',
	},
	actionDuplicate: {
		id: 'ptc-directory.agent-profile.action.dropdown.duplicate.nonfinal',
		defaultMessage: 'Duplicate Agent',
		description: 'Text for the Duplicate Agent action to create a duplicate',
	},
});
